import { Alert } from '@mui/material';
import dayjs from 'dayjs';
import { useWatch } from 'react-hook-form';
import { useHasAnyManualVisit } from './manual-reservation-warning.hooks';
import { useGetVisitsByDate } from './reservation-manual-date.hooks';
import { useIntlTranslations } from '@libs/intl/intl.hooks';

export const ManualReservationWarning = () => {
  const date = useWatch({ name: 'date' });
  const serviceIds = useWatch({ name: 'serviceIds' });
  const dateTo = useWatch({ name: 'dateTo' });
  const { t } = useIntlTranslations('AutomaticReservation');
  const visitsOnSelectedDate = useGetVisitsByDate(date);
  const getHasDayManualVisit = useHasAnyManualVisit(visitsOnSelectedDate);
  const hasDayManualVisit = getHasDayManualVisit(dayjs(date).format('YYYY-MM-DD'));

  if (!hasDayManualVisit || (hasDayManualVisit && !date && !dateTo)) {
    return null;
  }

  return (
    <Alert severity="error" sx={{ fontSize: '0.875rem' }}>
      {t('hasShortenedVisitWarning')}
    </Alert>
  );
};
